module.exports = __webpack_public_path__ + "static/media/six.c1b5b281.svg";